import Datepicker from 'vanillajs-datepicker/Datepicker';
import cs from 'vanillajs-datepicker/locales/cs';
import ru from 'vanillajs-datepicker/locales/ru';
import fa from "vanillajs-datepicker/locales/fa";
Object.assign(Datepicker.locales, cs);
Object.assign(Datepicker.locales, ru);


const reservationPanelInsurance = {
    _datePickerFrom: null,
    _reservationPanelNode: null,
    _lang: null,
    _stayNightsNode: null,
    _dateToNode: null,


    _monthTranslate: {
        "cs": ["leden","únor","březen","duben","květen","červen","červenec","srpen","září","říjen","listopad","prosinec"],
        "en": ["January","February","March","April","May","June","July","August","September","October","November","December"],
        "de": ["Januar", "Februar", "März", "April", "Mai", "Juni", "Juli", "August", "September", "Oktober", "November", "Dezember"],
        "ru": ["январь", "февраль", "март", "апрель", "май", "июнь", "июль", "август", "сентябрь", "октябрь", "ноябрь", "декабрь"]
    },

    _translations: {
        cs: { adults: ['dospělý', 'dospělí', 'dospělých'], children: ['dítě', 'děti', 'dětí'], room: 'Pokoj' },
        en: { adults: ['adult', 'adults'], children: ['child', 'children'], room: 'Room' },
        de: { adults: ['Erwachsener', 'Erwachsene'], children: ['Kind', 'Kinder'], room: 'Zimmer' },
        ru: { adults: ['взрослый', 'взрослых'], children: ['ребёнок', 'ребёнка', 'детей'], room: 'Номер' },
    },

    init() {
        if(! document.querySelector('.js-reservation-panel-insurance')) {
             return;
        }

        this._reservationPanelNode = document.querySelector('.js-reservation-panel-insurance');


        if (!this._reservationPanelNode.classList.contains('js-reservation-panel-insurance--initialized')) {
            this._dateToNode = this._reservationPanelNode.querySelector('.js-date-to');
            this._stayNightsNode = this._reservationPanelNode.querySelector('.js-stay-nights');
            this._buttonNode = this._reservationPanelNode.querySelector('.js-reservation-panel__button');
            this._constructDatePicker();

            this._stayNightsNodeHandler = (event) => {
                this._updateValueTo(this._datePickerFrom.getDate());
                this.updateLink();
            };
            this._stayNightsNode.addEventListener('change', this._stayNightsNodeHandler);

            this._reservationPanelNode.classList.add('js-reservation-panel-insurance--initialized');
        }


        this.updateLink();
    },

    updateLink() {
        let newURL = this._buttonNode.dataset.url;

        newURL = newURL.replace('[$dateFrom]', this._convertDate(this._datePickerFrom.getDate()));
        newURL = newURL.replace('[$dateTo]', this._convertDate(this._dateTo));
        newURL = newURL.replace('[$lang]', this._lang);
        newURL = newURL.replace('[$guests]', this._getGuests());

        this._buttonNode.href = newURL;
    },

    _constructDatePicker() {
        let datePickerFrom = this._reservationPanelNode.querySelector('.js-datepicker-from');
        this._lang = document.getElementsByTagName('html')[0].getAttribute('lang');

        this._datePickerFrom =  new Datepicker(datePickerFrom, {
            language:  this._lang,
            format: 'yyyy-mm-dd',
            autohide: false,
            minDate: new Date(),
            defaultViewDate: new Date()
        });

        this._datePickerFrom.setDate(new Date());

        this._updateValueFrom(this._datePickerFrom);

        datePickerFrom.addEventListener('changeDate', () => {
            this._updateValueFrom(this._datePickerFrom);
            this._datePickerFrom.hide();
        });
    },

    _getGuests() {
        let adultsCount = parseInt(this._reservationPanelNode.querySelector('.js-reservation-adults-count input').value) || 0;
        let roomGuests = [];
        let guestStrings = [];

        for (let i = 0; i < adultsCount; i++) {
            roomGuests.push('A');
        }

        guestStrings.push(roomGuests.join('%2C'));

        return guestStrings.join('%7C');
    },

    _updateValueFrom(datePickerFrom) {
        if(datePickerFrom.getDate() !== undefined) {
            let dateObjectFrom = new Date(datePickerFrom.getDate());
            let fakePickerFrom = datePickerFrom.element.parentElement.querySelector('.js-fake-datepicker-from');
            fakePickerFrom.querySelector('.js-fake-datepicker__date').innerHTML = dateObjectFrom.getDate() + ' ' + this._monthTranslate[this._lang][dateObjectFrom.getMonth()];
            this._updateValueTo(dateObjectFrom);
        }

        this.updateLink();
    },

    _updateValueTo(dateObjectFrom) {
        const selectedNights = parseInt(this._stayNightsNode.value, 10);
        this._dateTo = new Date(dateObjectFrom);
        this._dateTo.setDate(this._dateTo.getDate() + selectedNights);
        this._dateToNode.innerHTML = this._dateTo.getDate() + ' ' + this._monthTranslate[this._lang][this._dateTo.getMonth()];
    },

    _convertDate(date) {
        if (!date) return '';
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    },
}


window.reservationPanelInsurance = reservationPanelInsurance;

window.reservationPanelInsurance.init();

document.addEventListener('LokiRequestEnd', function () {
    window.reservationPanelInsurance.init();
});

